/** Textos da secção "vip". Chaves planas "vip.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    // Cabeçalho da secção
    "vip.eyebrow": "Apoia o servidor",
    "vip.title": "Planos VIP",
    "vip.introBefore": "Escolhe o teu tier, recebe vantagens in-game e ajuda a manter os servidores vivos. Clica em",
    "vip.introAfter": "para ver o inventário estilo Rust.",

    // Cartões
    "vip.weekly": "Semanal",
    "vip.monthly": "Mensal",
    "vip.promo": "Promoção · {label}",
    "vip.perMonth": "por mês",
    "vip.perWeek": "por semana",
    "vip.bestValue": "Melhor custo-benefício",
    "vip.benefits": "Benefícios",
    "vip.viewKit": "Ver itens do kit",
    "vip.subscribe": "Assinar {name}",
    "vip.custom.price": "Negociável com admins",
    "vip.custom.priceNote": "Orçamento e kit definidos na simulação",
    "vip.custom.cta": "Criar VIP",

    // Modal do kit
    "vip.kitModal.eyebrow": "Kit incluso",
    "vip.kitModal.title": "VIP {name}",
    "vip.kitModal.close": "Fechar",
    "vip.kitModal.closeModal": "Fechar modal",
    "vip.kitModal.empty": "Não há inventário configurado para este plano.",
    "vip.kitModal.main": "Itens principais",
    "vip.kitModal.wear": "Roupa (Wear)",
    "vip.kitModal.belt": "Cinto (Belt)",
    "vip.kitModal.inventory": "Inventário",
    "vip.kitModal.itemCount": "({count} itens)",
    "vip.kitModal.hotbar": "Hotbar",
    "vip.kitModal.armor": "Roupa + armadura",
    "vip.kitModal.slot.Cabeça": "Cabeça",
    "vip.kitModal.slot.Máscara": "Máscara",
    "vip.kitModal.slot.Tronco": "Tronco",
    "vip.kitModal.slot.Cintura": "Cintura",
    "vip.kitModal.slot.Mãos": "Mãos",
    "vip.kitModal.slot.Pernas": "Pernas",
    "vip.kitModal.slot.Pés": "Pés",
};

const en = {
    // Section header
    "vip.eyebrow": "Support the server",
    "vip.title": "VIP Plans",
    "vip.introBefore": "Pick your tier, get in-game perks and help keep the servers alive. Click",
    "vip.introAfter": "to see the Rust-style inventory.",

    // Cards
    "vip.weekly": "Weekly",
    "vip.monthly": "Monthly",
    "vip.promo": "Sale · {label}",
    "vip.perMonth": "per month",
    "vip.perWeek": "per week",
    "vip.bestValue": "Best value",
    "vip.benefits": "Benefits",
    "vip.viewKit": "View kit items",
    "vip.subscribe": "Get {name}",
    "vip.custom.price": "Negotiable with admins",
    "vip.custom.priceNote": "Budget and kit set in the simulator",
    "vip.custom.cta": "Create VIP",

    // Kit modal
    "vip.kitModal.eyebrow": "Included kit",
    "vip.kitModal.title": "VIP {name}",
    "vip.kitModal.close": "Close",
    "vip.kitModal.closeModal": "Close modal",
    "vip.kitModal.empty": "No inventory configured for this plan.",
    "vip.kitModal.main": "Main inventory",
    "vip.kitModal.wear": "Clothing (Wear)",
    "vip.kitModal.belt": "Belt",
    "vip.kitModal.inventory": "Inventory",
    "vip.kitModal.itemCount": "({count} items)",
    "vip.kitModal.hotbar": "Hotbar",
    "vip.kitModal.armor": "Clothing + armor",
    "vip.kitModal.slot.Cabeça": "Head",
    "vip.kitModal.slot.Máscara": "Face",
    "vip.kitModal.slot.Tronco": "Chest",
    "vip.kitModal.slot.Cintura": "Waist",
    "vip.kitModal.slot.Mãos": "Hands",
    "vip.kitModal.slot.Pernas": "Legs",
    "vip.kitModal.slot.Pés": "Feet",
};

export default { pt, en };
